// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-23245ea7] {\n  max-height: calc(100vh - 325px) !important;\n}", ""]);
// Exports
module.exports = exports;
